import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { compose } from 'redux';
import { Provider } from '../../common/ComponentIdContext';
import { ComponentNameProvider } from '../../common/ComponentNameContext';
import { ChanelConfig } from '../../../configs/GlobalConfig';
import MessageHub from '../../../core/signalr/SignalrMessageHub';
import ScrollComponent from '../../common/ScrollComponent';
import Tab from '../../common/tab';
import PreRender from '../../common/PreRender';
import { getCodeFromQuery, getQueryParams } from '../../helpers/Common';
import { TABS } from './Const';
import {
  fetchCompanyScore,
  fetchLatestPrice,
  fetchLatestPriceSuccess,
  REDUCER_NAME,
  setCode,
  updateSkip,
} from './reducer';
import TabContent from './TabContent';
import ScoreBox from '../common/header/score-box';
import Notifications from '../common/header/notifications';
import GroupButton from '../common/header/group-button';
import SearchBox from './common/SearchBox';
import './financial-statement.scss';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';

class FinancialStatement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTab:
        props.tab ||
        currentState.get(
          ConstCommon.listComponent.FinancialStatement,
          'currentTab',
          props.id,
        ) ||
        TABS.BALANCE_SHEET,
    };
    const { setCode, id } = this.props;
    const codeFromQuery = getCodeFromQuery(['stock']);
    if (codeFromQuery) {
      setCode(codeFromQuery, id);
      this.fetchData();
    }
  }

  componentDidMount() {
    const { code } = this.props;
    if (code && !getQueryParams('code')) {
      this.fetchData();
    }
    MessageHub.subscribe(ChanelConfig.TickChanel, this.onReceivePriceData);
  }

  componentDidUpdate(prevProps) {
    const { code, locale } = this.props;
    if (code !== prevProps.code || locale !== prevProps.locale) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    MessageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceivePriceData);
  }

  fetchData = () => {
    const { code, fetchLatestPrice, id, fetchCompanyScore } = this.props;
    fetchLatestPrice(
      {
        Code: code,
      },
      id,
    );

    fetchCompanyScore(
      {
        OrganCode: code,
      },
      id,
    );
  };

  onReceivePriceData = data => {
    const { code, fetchLatestPriceSuccess, id } = this.props;
    const price = data.find(item => item.ticker === code);
    if (price) {
      fetchLatestPriceSuccess(
        {
          priceInfo: price,
        },
        id,
      );
    }
  };

  changeTab = currentTab => {
    const { id, updateSkip } = this.props;

    currentState.add(
      ConstCommon.listComponent.FinancialStatement,
      'currentTab',
      currentTab,
      id,
    );

    this.setState({
      currentTab,
    });
    updateSkip(id, 0);
  };

  render() {
    const { currentTab } = this.state;
    const { id, code, ticker, score } = this.props;
    if (!code) {
      return null;
    }

    return (
      <PreRender {...this.props}>
        <ComponentNameProvider
          value={ConstCommon.listComponent.FinancialStatement}
        >
          <Provider value={id}>
            <ScrollComponent>
              <div className="pl-20 pr-20 pt-8 financial-statement-wrapper min-height-100 h-100">
                <div className="top-nav d-flex flex-column h-100">
                  <div className="d-flex mb-10 align-items-center flex-shrink-0">
                    <SearchBox componentId={id} />
                    <ScoreBox data={score} />
                    <GroupButton code={ticker} />
                    <Notifications data={score} />
                  </div>
                  <Tab
                    currentTab={currentTab}
                    listTab="financialStatement.tabs"
                    changeTab={this.changeTab}
                  />
                  <div className="tab-content flex-fill h-auto d-flex flex-column">
                    <TabContent componentId={id} currentTab={currentTab} />

                    <div className="footer-note d-flex">
                      {I18n.t('financialStatement.footerNote')}

                      <div className="powered-by-fiinTrade ml-auto mt-0">
                        {I18n.t('common.poweredByFiinTrade')}
                        <a href="https://fiintrade.vn" target="_blank">
                          FiinTrade
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollComponent>
          </Provider>
        </ComponentNameProvider>
      </PreRender>
    );
  }
}

FinancialStatement.propTypes = {
  fetchLatestPrice: PropTypes.func.isRequired,
  fetchLatestPriceSuccess: PropTypes.func.isRequired,
  code: PropTypes.string.isRequired,
  ticker: PropTypes.string.isRequired,
  fetchCompanyScore: PropTypes.func.isRequired,
  score: PropTypes.object.isRequired,
};

const mapStateToProps = (state, { id }) => ({
  code: state[REDUCER_NAME][id].currentSearch.code,
  ticker: state[REDUCER_NAME][id].currentSearch.ticker,
  score: state[REDUCER_NAME][id].score,
  locale: state.i18n.locale,
});

const mapDispatchToProps = {
  fetchLatestPrice,
  fetchLatestPriceSuccess,
  fetchCompanyScore,
  updateSkip,
  setCode,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(FinancialStatement);
